import * as NetatmoCommon from '../NetatmoCommon';

export const convertSolarReportToAnnual = (
  report: Record<'solar', Record<string, number[]>>,
  year: number,
) => {
  const months = Array.from({length: 12}, (_, key) => key + 1);

  const annualReport = {
    solar: {},
  } as Record<'solar', Record<string, number[]>>;

  months.forEach((month) => {
    const formattedMonth = `${year}/${month.toString().padStart(2, '0')}`;
    annualReport.solar[formattedMonth] = [
      NetatmoCommon.Utils.getAvg(
        Object.keys(report.solar)
          .filter((ts) => ts.startsWith(formattedMonth))
          .reduce(
            (obj, key) => {
              obj[key] = report.solar[key];
              return obj;
            },
            {} as Record<string, number[]>,
          ),
        0,
      ),
      NetatmoCommon.Utils.getMax(
        Object.keys(report.solar)
          .filter((ts) => ts.startsWith(formattedMonth))
          .reduce(
            (obj, key) => {
              obj[key] = report.solar[key];
              return obj;
            },
            {} as Record<string, number[]>,
          ),
        1,
      ),
      NetatmoCommon.Utils.getSum(
        Object.keys(report.solar)
          .filter((ts) => ts.startsWith(formattedMonth))
          .reduce(
            (obj, key) => {
              obj[key] = report.solar[key];
              return obj;
            },
            {} as Record<string, number[]>,
          ),
        2,
      ),
    ];
  });

  return annualReport;
};
